import { Children, type ReactNode } from 'react';
import { SparkleIcon } from '@phosphor-icons/react';

/**
 * O rodapé do planner: a nota do agente com o sparkle + as ações. É a casca do
 * `CardFooter` dos cards do genui-kit (as mesmas classes `fui-foot`/`fui-note`,
 * que `planner_card.css` veste aqui dentro), com uma diferença: a nota chega
 * como texto puro. O planner não recebe o renderer de markdown do chat; nenhum
 * host passa nota hoje, e um que precise de markdown troca o tipo da prop.
 *
 * Renderiza nada quando não sobra nota nem ação. `Children.toArray` e não
 * `!children`: com DOIS filhos condicionais o React entrega `[false, false]`,
 * que é truthy, e a banda saía vazia; `toArray` descarta booleano, `null` e
 * `undefined` e preserva o `0`.
 */
export function CardFooter({
  note,
  className,
  children,
}: {
  readonly note?: string;
  /** Utilitárias do DS somadas à casca (`fui-foot`) por quem pede outro ritmo. */
  readonly className?: string;
  readonly children?: ReactNode;
}): ReactNode {
  if (!note && Children.toArray(children).length === 0) return null;
  return (
    <div className={className ? `fui-foot ${className}` : 'fui-foot'}>
      {note && (
        <div className="fui-note">
          <SparkleIcon size={15} weight="fill" aria-hidden />
          <div className="fui-note-body">
            <p>{note}</p>
          </div>
        </div>
      )}
      {children}
    </div>
  );
}
